export const ITEMS = {
  PAGES: 'Dialogues',
  QA: 'Q&A',
  AUTOMATION_RULES: 'Automation Rules',
  SETTINGS: 'Settings',
  HTML_ELEMENTS: 'Facebook Opt-ins',
  FB_COMMENT_GUARD: 'FB Comment Guards',
  MESSENGER_ADS: 'Messenger Ads',
  LEAD_POPUPS: 'Opt-in popups',
  LANDING_PAGES: 'Landing Pages',
  SCAN_CODES: 'Scan Codes',
  CONNECTIONS: 'Connections',
  CHAT_BLASTER: 'Chat Blaster',
  PROMO_BLASTER: 'Sponsored Messages',
  CUSTOMER_CHAT: 'Customer Chat Widgets',
  SHARE_LINKS: 'Share Links',
  DRIP_CAMPAIGNS: 'Drip Campaigns',
  CONTACTS: 'Contacts',
  RSS_BLASTER: 'RSS Blaster',
  MOBILE_MONKEY_API: 'MobileMonkey API',
  ZAPIER: 'Zapier',
  FIND_TEMPLATE_BY_CODE: 'Find template by code',
  MY_TEMPLATES: 'My templates',
  FACEBOOK_PAGE_WELCOMER: 'Facebook Page Welcomer',
  FACEBOOK_CLICK_TO_MESSENGER_ADS: 'Click-To-Messenger Ads',
  SMS_KEYWORDS: 'Keywords',
  INSTAGRAM_WELCOMER: 'Instagram DM Responder',
  INSTAGRAM_STORY_MENTION: 'Instagram Story Mentions',
  INSTAGRAM_STORY_REACTIONS: 'Instagram Story Reactions',
  INSTAGRAM_LIVE_COMMENT_GUARD: 'Instagram Live',
};
